/** each component are standalone and they shouldn't be mixed */

import { Mouse } from "./Mouse";
import { Trigger } from "./Trigger";

export const Tooltip = {
  Mouse,
  Trigger,
};
